class Pedido{
    constructor(id, cliente_id, user_id, estado, forma_pago, movimiento_id, total, created_at, cliente, user, movimiento, detalles, entrega){
        this.id = id;
        this.cliente_id = cliente_id;
        this.user_id = user_id;
        this.estado = estado;
        this.movimiento_id = movimiento_id;
        this.total = total;
        this.created_at = created_at;
        this.cliente = cliente;
        this.user = user;
        this.movimiento = movimiento;
        this.detalles = detalles;
        this.forma_pago = forma_pago;
        this.entrega = entrega;
    }
}
export default Pedido;